import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// Protected Views
import {
    Login,
    Layout,
    Recover,
    Error500,
    NotFound,
    Dashboard,
    Maintenance,
    NominaReglas,
    NominaSecuencias,
    NominaTurnos,
    CuadroTurnos,
} from "./core/ui/pages/index";

import BasePage from "./core/ui/components/Layout/BasePage";
import Gerente from "./modules/NominaHorasExtras/ui/pages/gerente";
import Financiera from "./modules/NominaHorasExtras/ui/pages/financiera";
import Informes from "./modules/NominaHorasExtras/ui/pages/informes";
import HorasExtras from "./modules/NominaHorasExtras/ui/pages/horasExtras";
import PersonasActivas from "./modules/Personas/ui/pages/personas-activas";
import PersonasInactivas from "./modules/Personas/ui/pages/personas-inactivas";
import GestionarSolicitudes from "./modules/Solicitudes/ui/pages/soporte/solicitudes-gestionar-soporte";
import SolicitudesSoporte from "./modules/Solicitudes/ui/pages/soporte/solicitar-soporte";
import CiudadesSolicitudes from "./modules/Solicitudes/ui/pages/ciudades";
import SedesSolicitudes from "./modules/Solicitudes/ui/pages/sedes";
import AreasSolicitudes from "./modules/Solicitudes/ui/pages/areas";
import ProcesoSolicitudes from "./modules/Solicitudes/ui/pages/soporte/solicitudes-proceso-soporte";
import CerradasSolicitudes from "./modules/Solicitudes/ui/pages/soporte/solicitudes-cerradas-soporte";
import SolicitudesMisionalGH from "./modules/Solicitudes/ui/pages/gestionHumana/solicitudes-misional-GH";
import SolicitudesAdministrativaGH from "./modules/Solicitudes/ui/pages/gestionHumana/solicitudes-administrativa-GH";
import SolicitudesDireccionGH from "./modules/Solicitudes/ui/pages/gestionHumana/solicitudes-direccion-GH";
import SolicitudesGerenciaGH from "./modules/Solicitudes/ui/pages/gestionHumana/solicitudes-gerencia-GH";
import SolicitudesEnProcesoGH from "./modules/Solicitudes/ui/pages/gestionHumana/solicitudes-proceso-GH";

import Sedes from "./modules/Sedes/ui/pages/sedes";
import Forbidden from "./core/ui/pages/forbidden";
import MisReservas from "./modules/Reservas/ui/pages/mis-reservas";
import Reservar from "./modules/Reservas/ui/pages/reservar";
import ReservasSedes from "./modules/Reservas/ui/pages/seleccion-sedes";
import ReservasLayout from "./modules/Reservas/ui/components/reservas-layout";
import Configuraciones from "./modules/NominaConfiguraciones/ui/pages/configuraciones";
import Festivos from "./modules/Festivos/ui/pages/festivos";
import Parametros from "./modules/Parametros/ui/pages/parametros";
import TiposParametros from "./modules/Parametros/ui/pages/tipos-parametros";
import Cargos from "./modules/Cargos/ui/pages/cargos";
import VersionesContratos from "./modules/Contratos/ui/pages/versiones-contratos";
import Software from "./modules/Software/ui/pages/software";
import SeleccionRecurso from "./modules/Reservas/ui/pages/seleccion-recursos";
import Recursos from "./modules/Reservas/ui/pages/recursos";
import TiposSolicitudes from "./modules/Solicitudes/ui/pages/tipos-solicitudes";
import { CuadroTurnosProvider } from "./modules/NominaCuadrosTurnos/store/cuadro-turnos-context";
import { SolicitudesLayout } from "./modules/Solicitudes/store/solicitudes-layout";
import Permisos from "./modules/Permisos/ui/pages/permisos";
import GruposPermisos from "./modules/Permisos/ui/pages/grupos-permisos";
import EntidadesPensiones from "./modules/Entidades/ui/pages/entidades-pension";
import EntidadesSalud from "./modules/Entidades/ui/pages/entidades-salud";
import Areas from "./modules/Areas/ui/pages/areas";
import SubAreas from "./modules/SebAreas/ui/pages/subAreas";
import Actividades from "./modules/Actividades/ui/pages/actividades";

export default function CustomRoutes() {
    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={<BasePage />}>
                    <Route path="login" element={<Login />} />
                    <Route path="recover" element={<Recover />} />
                    <Route path="notfound" element={<NotFound />} />
                    <Route path="error500" element={<Error500 />} />
                    <Route path="forbidden" element={<Forbidden />} />
                    <Route path="maintenance" element={<Maintenance />} />
                </Route>

                <Route path="dashboard" element={<Layout />}>
                    <Route index element={<Dashboard />} />
                </Route>
                <Route
                    path="nomina-turnos"
                    element={<Layout permissions={["nominaListarTurnos"]} />}
                >
                    <Route index element={<NominaTurnos />} />
                </Route>
                <Route
                    path="cuadro-turnos"
                    element={
                        <Layout permissions={["nominaListarCuadroTurnos"]} />
                    }
                >
                    <Route
                        index
                        element={
                            <CuadroTurnosProvider>
                                <CuadroTurnos />
                            </CuadroTurnosProvider>
                        }
                    />
                </Route>
                <Route
                    path="horas-extras-nomina"
                    element={<Layout permissions={["listarHorasExtras"]} />}
                >
                    <Route index element={<HorasExtras />} />
                </Route>
                <Route
                    path="reglas"
                    element={<Layout permissions={["nominaListarReglas"]} />}
                >
                    <Route index element={<NominaReglas />} />
                </Route>
                <Route
                    path="secuencias"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<NominaSecuencias />} />
                </Route>
                <Route
                    path="actividades"
                    element={<Layout permissions={["actividadesListar"]} />}
                >
                    <Route index element={<Actividades />} />
                </Route>
                <Route
                    path="informes"
                    element={<Layout permissions={["nominaListarInforme"]} />}
                >
                    <Route index element={<Informes />} />
                </Route>
                <Route
                    path="gerente"
                    element={<Layout permissions={["nominaListarGerente"]} />}
                >
                    <Route index element={<Gerente />} />
                </Route>
                <Route
                    path="financiera"
                    element={
                        <Layout permissions={["nominaListarFinanciera"]} />
                    }
                >
                    <Route index element={<Financiera />} />
                </Route>

                <Route path="solicitudes" element={<Layout permissions={[]} />}>
                    <Route path="" element={<SolicitudesLayout />}>
                        <Route
                            path="ciudades"
                            element={<CiudadesSolicitudes />}
                        />
                        <Route path="sedes" element={<SedesSolicitudes />} />
                        <Route path="areas" element={<AreasSolicitudes />} />
                        <Route path="tipos" element={<TiposSolicitudes />} />
                        <Route
                            path="soporte"
                            element={<SolicitudesSoporte />}
                        />
                    </Route>
                </Route>

                <Route
                    path="gestionarSolicitudes"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<GestionarSolicitudes />} />
                </Route>
                <Route
                    path="solicitudesProceso"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<ProcesoSolicitudes />} />
                </Route>
                <Route
                    path="solicitudesCerradas"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<CerradasSolicitudes />} />
                </Route>
                <Route
                    path="solicitudesMisionalGH"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<SolicitudesMisionalGH />} />
                </Route>
                <Route
                    path="solicitudesAdministrativaGH"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<SolicitudesAdministrativaGH />} />
                </Route>
                <Route
                    path="solicitudesDireccionGH"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<SolicitudesDireccionGH />} />
                </Route>
                <Route
                    path="solicitudesGerenciaGH"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<SolicitudesGerenciaGH />} />
                </Route>
                <Route
                    path="solicitudesEnProcesoGH"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<SolicitudesEnProcesoGH />} />
                </Route>
                <Route
                    path="personasActivas"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<PersonasActivas />} />
                </Route>
                <Route
                    path="personasInactivas"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<PersonasInactivas />} />
                </Route>
                <Route
                    path="configuraciones"
                    element={<Layout permissions={[]} />}
                >
                    <Route index element={<Configuraciones />} />
                </Route>

                <Route
                    path="reservas"
                    element={<Layout permissions={["reservasCrearReserva"]} />}
                >
                    <Route path="" element={<ReservasLayout />}>
                        <Route index element={<ReservasSedes />} />
                        <Route path="recursos" element={<SeleccionRecurso />} />
                        <Route path="reservar" element={<Reservar />} />
                    </Route>
                </Route>
                <Route
                    path="recursos"
                    element={
                        <Layout permissions={["reservasListarRecursos"]} />
                    }
                >
                    <Route index element={<Recursos />} />
                </Route>
                <Route
                    path="mis-reservas"
                    element={<Layout permissions={["reservasListarReserva"]} />}
                >
                    <Route index element={<MisReservas />} />
                </Route>

                <Route path="sedes" element={<Layout permissions={[]} />}>
                    <Route index element={<Sedes />} />
                </Route>

                <Route
                    path="permisos"
                    element={<Layout permissions={["permisosListar"]} />}
                >
                    <Route index element={<Permisos />} />
                </Route>

                <Route
                    path="gruposPermisos"
                    element={<Layout permissions={["gruposPermisosListar"]} />}
                >
                    <Route index element={<GruposPermisos />} />
                </Route>

                <Route
                    path="festivos"
                    element={<Layout permissions={["festivosListar"]} />}
                >
                    <Route index element={<Festivos />} />
                </Route>

                <Route
                    path="parametros"
                    element={<Layout permissions={["listarParametros"]} />}
                >
                    <Route index element={<Parametros />} />
                </Route>

                <Route
                    path="tipos_parametros"
                    element={<Layout permissions={["listarTiposParametros"]} />}
                >
                    <Route index element={<TiposParametros />} />
                </Route>

                <Route
                    path="cargos"
                    element={<Layout permissions={["cargosListar"]} />}
                >
                    <Route index element={<Cargos />} />
                </Route>
                <Route
                    path="areas"
                    element={<Layout permissions={["areasListar"]} />}
                >
                    <Route index element={<Areas />} />
                </Route>
                <Route
                    path="subAreas"
                    element={<Layout permissions={["cargosListar"]} />}
                >
                    <Route index element={<SubAreas />} />
                </Route>

                <Route
                    path="versiones_contratos"
                    element={
                        <Layout permissions={["versionesContratosListar"]} />
                    }
                >
                    <Route index element={<VersionesContratos />} />
                </Route>

                <Route
                    path="entidades_salud"
                    element={<Layout permissions={["listarEntidadesSalud"]} />}
                >
                    <Route index element={<EntidadesSalud />} />
                </Route>
                <Route
                    path="entidades_pension"
                    element={
                        <Layout permissions={["listarEntidadesPension"]} />
                    }
                >
                    <Route index element={<EntidadesPensiones />} />
                </Route>
                <Route path="software" element={<Layout permissions={[]} />}>
                    <Route index element={<Software />} />
                </Route>

                <Route
                    path=""
                    exact
                    index
                    element={<Navigate to="/dashboard" />}
                />

                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}
